export const MAX_SIZE_2GB = 2147483648;

export const TRANSFORMATION_CONFIG = {
  lang: "en",
  editor: {
    closeOnSave: true, // decide if save should close modal window
    topMenu: {
      lockRotation: false, // lock top layer menu rotation
      lockFlip: false, // lock top flip menu
      remove: true, // enable top menu remove button
      layers: true // enable top menu layers management
    },
    transforms: {
      enabled: true, // enable or disable transform module
      lockRotation: false,
      lockFlip: false,
      ratios: [
        {
          icon: "crop_free",
          default: true,
          name: "Custom",
          shape: "rect"
        },
        {
          icon: `<svg><circle cx="10" cy="10" r="8" stroke="white" stroke-width="2" fill="transparent"/></svg>`,
          name: "Circle",

          lockRatio: true // Controls whether the ratio is user-editable
        },
        {
          icon: "crop_16_9",
          name: "16/9", // The default translation for this ratio
          shape: "rect", // rect, circle
          ratio: 16 / 9, // The image aspect ratio (a floating point number) or
          lockRatio: true // Controls whether the ratio is user-editable
        }
      ]
    },
    text: {
      defaults: {
        // initial text tool values after creating text
        size: 100,
        color: "#000000",
        backgroundColor: "transparent",
        bold: false,
        italic: false,
        underline: false,
        align: "left",
        initialText: "Example text."
      },
      // font list visible in editor
      fonts: [
        {
          default: true, // set default font for text-tool
          displayName: "Times New Roman",
          family: "Times New Roman, Times, serif"
        },
        {
          displayName: "Georgia",
          family: "Georgia, serif"
        },
        {
          displayName: "Palatino Linotype",
          family: "Palatino Linotype, Book Antiqua, Palatino, serif"
        },
        {
          displayName: "Arial",
          family: "Arial, Helvetica, sans-serif"
        },
        {
          displayName: "Arial Black",
          family: "Arial Black, Gadget, sans-serif"
        },
        {
          displayName: "Comic Sans MS",
          family: "Comic Sans MS, cursive, sans-serif"
        },
        {
          displayName: "Impact",
          family: "Impact, Charcoal, sans-serif"
        },
        {
          displayName: "Lucida Sans",
          family: "Lucida Sans Unicode, Lucida Grande, sans-serif"
        },
        {
          displayName: "Tahoma",
          family: "Tahoma, Geneva, sans-serif"
        },
        {
          displayName: "Trebuchet MS",
          family: "Trebuchet MS, Helvetica, sans-serif"
        },
        {
          displayName: "Courier New",
          family: "Courier New, Courier, monospace"
        },
        {
          displayName: "Verdana",
          family: "Verdana, Geneva, sans-serif"
        },
        {
          displayName: "Lucida Console",
          family: "Lucida Console, Monaco, monospace"
        },
        {
          displayName: "TLobster",
          family: "Lobster",
          cssUrl: "https://fonts.googleapis.com/css?family=Lobster&display=swap" // we can also load own custom fonts from ie google api or customer defined url
        }
      ]
    },
    border: {
      enabled: true,
      defaults: {
        width: 25,
        opacity: 50,
        shadow: false,
        color: "#000"
      }
    },
    filters: {
      // enabled: true - enable all adjustments or false to disable this module
      enabled: [
        "blackWhite",
        "brownie",
        "kodachrome",
        "polaroid",
        "sepia",
        "technicolor",
        "vintage",
        "iceCold",
        "vanillaSky",
        "blueOcean",
        "autumn",
        "milkyWay"
      ]
      // @example
      // custom: [
      //   {
      //     id: 'milkyWay',
      //     displayName: 'Milky way',
      //     matrix: [0, 1.0, 0, 0, 0, 0, 1.0, 0, 0, 0, 0, 0.6, 1.2, 0, 0, 0, 0, 0, 0.9, 0],
      //   },
      // ],
    },
    adjustments: {
      enabled: [
        "brightness",
        "gamma",
        "saturation",
        "contrast",
        "hue",
        "noise",
        "blur",
        "pixelate"
      ]
      // enabled: true - enable all adjustments or false to disable this module
    },
    overlay: {
      enabled: true,
      defaults: {
        opacity: 100
      }
    }
  },
  output: {
    format: "png",
    quality: 1,
    blob: false, // export file as blob or url
    name: null // output file name if null name will be extracted from url or file element
  }
};

export const TRANSFORMATION_CROP_SQUARE_CONFIG = {
  lang: "en",
  editor: {
    closeOnSave: true,
    topMenu: {
      lockRotation: false,
      lockFlip: false,
      remove: true,
      layers: true
    },
    transforms: {
      enabled: true,
      lockRotation: false,
      lockFlip: false,
      ratios: [
        {
          default: true,
          icon: "crop_free",
          name: "1:1",
          shape: "rect",
          ratio: 1,
          lockRatio: true
        }
      ]
    },
    text: {
      defaults: {
        size: 100,
        color: "#000000",
        backgroundColor: "transparent",
        bold: false,
        italic: false,
        underline: false,
        align: "left",
        initialText: "Example text."
      },
      fonts: [
        {
          default: true,
          displayName: "Times New Roman",
          family: "Times New Roman, Times, serif"
        },
        {
          displayName: "Georgia",
          family: "Georgia, serif"
        },
        {
          displayName: "Palatino Linotype",
          family: "Palatino Linotype, Book Antiqua, Palatino, serif"
        },
        {
          displayName: "Arial",
          family: "Arial, Helvetica, sans-serif"
        },
        {
          displayName: "Arial Black",
          family: "Arial Black, Gadget, sans-serif"
        },
        {
          displayName: "Comic Sans MS",
          family: "Comic Sans MS, cursive, sans-serif"
        },
        {
          displayName: "Impact",
          family: "Impact, Charcoal, sans-serif"
        },
        {
          displayName: "Lucida Sans",
          family: "Lucida Sans Unicode, Lucida Grande, sans-serif"
        },
        {
          displayName: "Tahoma",
          family: "Tahoma, Geneva, sans-serif"
        },
        {
          displayName: "Trebuchet MS",
          family: "Trebuchet MS, Helvetica, sans-serif"
        },
        {
          displayName: "Courier New",
          family: "Courier New, Courier, monospace"
        },
        {
          displayName: "Verdana",
          family: "Verdana, Geneva, sans-serif"
        },
        {
          displayName: "Lucida Console",
          family: "Lucida Console, Monaco, monospace"
        },
        {
          displayName: "TLobster",
          family: "Lobster",
          cssUrl: "https://fonts.googleapis.com/css?family=Lobster&display=swap"
        }
      ]
    },
    border: {
      enabled: true,
      defaults: {
        width: 25,
        opacity: 50,
        shadow: false,
        color: "#000"
      }
    },
    filters: {
      enabled: [
        "blackWhite",
        "brownie",
        "kodachrome",
        "polaroid",
        "sepia",
        "technicolor",
        "vintage",
        "iceCold",
        "vanillaSky",
        "blueOcean",
        "autumn",
        "milkyWay"
      ]
    },
    adjustments: {
      enabled: [
        "brightness",
        "gamma",
        "saturation",
        "contrast",
        "hue",
        "noise",
        "blur",
        "pixelate"
      ]
    },
    overlay: {
      enabled: true,
      defaults: {
        opacity: 100
      }
    }
  },
  output: {
    format: "png",
    quality: 1,
    blob: false,
    name: null
  }
};

export const TRANSFORMATION_CROP_RECTANGLE_CONFIG = {
  lang: "en",
  editor: {
    closeOnSave: true,
    topMenu: {
      lockRotation: false,
      lockFlip: false,
      remove: true,
      layers: true
    },
    transforms: {
      enabled: true,
      lockRotation: false,
      lockFlip: false,
      ratios: [
        {
          default: true,
          icon: "crop_16_9",
          name: "4:1",
          shape: "rect",
          ratio: 4 / 1,
          lockRatio: true
        }
      ]
    },
    text: {
      defaults: {
        size: 100,
        color: "#000000",
        backgroundColor: "transparent",
        bold: false,
        italic: false,
        underline: false,
        align: "left",
        initialText: "Example text."
      },
      fonts: [
        {
          default: true,
          displayName: "Times New Roman",
          family: "Times New Roman, Times, serif"
        },
        {
          displayName: "Georgia",
          family: "Georgia, serif"
        },
        {
          displayName: "Palatino Linotype",
          family: "Palatino Linotype, Book Antiqua, Palatino, serif"
        },
        {
          displayName: "Arial",
          family: "Arial, Helvetica, sans-serif"
        },
        {
          displayName: "Arial Black",
          family: "Arial Black, Gadget, sans-serif"
        },
        {
          displayName: "Comic Sans MS",
          family: "Comic Sans MS, cursive, sans-serif"
        },
        {
          displayName: "Impact",
          family: "Impact, Charcoal, sans-serif"
        },
        {
          displayName: "Lucida Sans",
          family: "Lucida Sans Unicode, Lucida Grande, sans-serif"
        },
        {
          displayName: "Tahoma",
          family: "Tahoma, Geneva, sans-serif"
        },
        {
          displayName: "Trebuchet MS",
          family: "Trebuchet MS, Helvetica, sans-serif"
        },
        {
          displayName: "Courier New",
          family: "Courier New, Courier, monospace"
        },
        {
          displayName: "Verdana",
          family: "Verdana, Geneva, sans-serif"
        },
        {
          displayName: "Lucida Console",
          family: "Lucida Console, Monaco, monospace"
        },
        {
          displayName: "TLobster",
          family: "Lobster",
          cssUrl: "https://fonts.googleapis.com/css?family=Lobster&display=swap"
        }
      ]
    },
    border: {
      enabled: true,
      defaults: {
        width: 25,
        opacity: 50,
        shadow: false,
        color: "#000"
      }
    },
    filters: {
      enabled: [
        "blackWhite",
        "brownie",
        "kodachrome",
        "polaroid",
        "sepia",
        "technicolor",
        "vintage",
        "iceCold",
        "vanillaSky",
        "blueOcean",
        "autumn",
        "milkyWay"
      ]
    },
    adjustments: {
      enabled: [
        "brightness",
        "gamma",
        "saturation",
        "contrast",
        "hue",
        "noise",
        "blur",
        "pixelate"
      ]
    },
    overlay: {
      enabled: true,
      defaults: {
        opacity: 100
      }
    }
  },
  output: {
    format: "png",
    quality: 1,
    blob: false,
    name: null
  }
};
